import { bindLegacyService } from '@debatdirect/common/src/modules/register';
import { container } from '@debatdirect/common/src/modules/container';
import StorageService from '@debatdirect/common/src/services/StorageService';
import LogTransporter from '@debatdirect/common/src/services/logging/LogTransporter';
import ConsoleTransporter from '@debatdirect/common/src/services/logging/ConsoleTransporter';
import PlatformService from '@debatdirect/ui-react/src/services/PlatformService';
import { LogLevel } from '@debatdirect/common/src/services/logging/LogLevel';
import type { LegacyConfig } from '@debatdirect/common/types/legacy-config';
import LegacyRouterService from '@debatdirect/ui-react/src/services/LegacyRouterService';
import { LocalStorageService } from '@debatdirect/ui-react/src/services/LocalStorageService';
import AuthService from '@debatdirect/core/services/AuthService/AuthService';
import SocketService from '@debatdirect/ui-react/src/services/live/SocketService';
import { structure } from '@debatdirect/core/core';

import config from '#src/utils/config';
import routes from '#src/routes';

export const register = async () => {
  container.bind(StorageService).to(LocalStorageService);
  container.bind<LogTransporter>(LogTransporter).toDynamicValue(() => new ConsoleTransporter(import.meta.env.DEV ? LogLevel.DEBUG : LogLevel.ERROR));
  container.bind('platform').to(PlatformService);
  container.bind('router').to(LegacyRouterService);
  container.bind('live').to(SocketService);

  container.bind('auth').toDynamicValue(bindLegacyService(AuthService));

  container.bind<LegacyConfig>('config').toConstantValue(config);
  container.bind('structure').toConstantValue(structure);
  container.bind('routes').toConstantValue(routes);

  if (__LOAD_SENTRY__) {
    const { default: SentryLogTransporter } = await import('@debatdirect/ui-react/src/services/SentryLogTransporter');
    container.bind<LogTransporter>(LogTransporter).toDynamicValue(() => new SentryLogTransporter());
  }
};
